
import { LanguageContext } from "../../../context/LanguageContext";
import {
  InnerWrapper,
  MainContainer,
  TitleAndActionBox,
} from "../../common";
import { useContext, useEffect } from "react";
import { Box, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { analytics, triggerLogEvent } from "../../../config/firebase";
import { UBButton } from "../../../Libraries";
import NonIdealNew from "../../common/NonIdealNew";

const Saddar = () => {
  const [I18n] = useContext(LanguageContext);
  const navigate = useNavigate();

  const handleRoute = (route) => {
    navigate(route);
    if (route === "/ViewLedger") {
      triggerLogEvent(analytics, "sc_ledger");
    } else if (route === "/SaddarOrders") {
      triggerLogEvent(analytics, "sc_orders");
    } else {
      triggerLogEvent(analytics, "sc_stock");
    }
  };

  useEffect(() => {
    triggerLogEvent(analytics, "sc_discovered");
  });

  return (
    <MainContainer fluid>
      <Grid container>
        <Grid item md={12}>
          <TitleAndActionBox
            data={{
              title: "saddar_seller_central",
            }}
          >
            <Box display={"flex"} gap={"12px"}>
              <UBButton id="saddar_view_ledger_btn" title={I18n.view_ledger} className="ubPrimaryButton" onClick={() => handleRoute("/ViewLedger")} />
              <UBButton id="saddar_view_orders_btn" title={I18n.veiw_orders} className="ubPrimaryButton" onClick={() => handleRoute("/SaddarOrders")} />
              <UBButton id="saddar_manage_stock_btn" title={I18n.manage_stock} className="ubPrimaryButton" onClick={() => handleRoute("/SaddarInventory")} />
            </Box>
          </TitleAndActionBox>
          <InnerWrapper className="innerWrapper newInnerWrapper">
            <NonIdealNew
              title={I18n.saddar_seller_central}
              subtitle={I18n.manage_your_Saddar_store_inventory_and_look_after_the_payments}
              button1Title="view_ledger"
              onButton1Click={() => handleRoute("/ViewLedger")}
              loading={false}
              disabledOne={false}
              disabledTwo={false}
              buttonOneId={"view_ledger"}
              listButton2Title={"veiw_orders"}
              onListButton2Click={() => handleRoute("/SaddarOrders")}
              listButton3Title="manage_stock"
              onListButton3Click={() => handleRoute("/SaddarInventory")}
            />
          </InnerWrapper>
        </Grid>
      </Grid>
    </MainContainer>
  );
};

export default Saddar;
